import ColorUtil from "./ColorUtil";

export default class ThemeUtil {

    static newStyleGuide() {

        return {
            id: null,
            user_id: null,
            name: 'New Style Guide',
            header_font: {
                family: 'Lato',
                weight: '900',
            },
            text_font: {
                family: 'Roboto',
                weight: '300',
            },
        }
    }

    updateButtonStyles(bgColor, buttonObject) {

        let colorObject = ColorUtil.getColorObject(bgColor)
        buttonObject.background_color = bgColor
        let colorFamily = webase.utils.color.getFamilyColors(colorObject.color)
        let colorShade = Number(colorObject.shade)
        let contrastShade = colorShade > 400 ? 100 : 700
        buttonObject.color = colorFamily[contrastShade]
        buttonObject.border_color = colorFamily[contrastShade]
        let hoverBgShade = colorShade < 700 ? colorShade + 200 : colorShade - 200

        // ensure we don't end up with a missing color like 750
        if(colorShade === 50) {
            hoverBgShade = 300
        }

        buttonObject.hover_color = colorFamily[hoverBgShade]
        buttonObject.hover_border_color = colorFamily[hoverBgShade] // TODO: we can do better
    }

    updateDefaultCardTheme(currentTheme) {
        currentTheme.card.background_color = currentTheme.primary_background.background_color
        currentTheme.card.color = currentTheme.primary_background.color
        currentTheme.card.border_color = currentTheme.primary_background.color
        currentTheme.card.box_shadow_color = currentTheme.primary_background.background_color
    }

    convertToFullTheme(newTheme) {
        let theme = this.defaultTheme()
        theme.name = newTheme.name
        theme.primary_background.background_color = newTheme.primary.bgColor
        theme.primary_background.color = newTheme.primary.color
        theme.secondary_background.background_color = newTheme.secondary.bgColor ? newTheme.secondary.bgColor : newTheme.primary.color
        theme.secondary_background.color = newTheme.secondary.color ?  newTheme.secondary.color : newTheme.primary.bgColor
        theme.header_font = newTheme.header_font
        theme.text_font = newTheme.text_font

        theme.nav.background_color = newTheme.primary.color
        theme.nav.color = newTheme.primary.bgColor

        this.updateDefaultCardTheme(theme)
        this.updateButtonStyles(newTheme.ctaColor, theme.primary_button)
        this.updateButtonStyles(newTheme.primary.color, theme.secondary_button)
        return theme
    }

    newTheme() {

        // This is not a full theme, but just a partial one used for gathering top-level

        return {
            name: '',
            ctaColor: '',
            primary: {
                bgColor: '',
                color: '',
            },
            secondary: {
                bgColor: '',
                color: '',
            },
            header_font: {
                family: 'Lato',
                weight: '900',
            },
            text_font: {
                family: 'Inter',
                weight: 'regular',
            },
        }
    }

    defaultTheme() {

        return {
            id: null,
            user_id: null,
            name: 'New Theme',
            header_font: {
                family: 'Lato',
                weight: '900',
            },
            text_font: {
                family: 'Roboto',
                weight: '300',
            },
            primary_background: {
                type: 'solid',
                background_color: '#312e81',
                background_color2: '',
                color: '#fcfcfc'
            },
            secondary_background: {
                type: 'solid',
                background_color: '#171717',
                background_color2: '',
                color: '#fcfcfc'
            },
            primary_button: {
                background_color: "#1d4ed8",
                hover_color: '#1e40af',
                color: '#fcfcfc',
                border_color: '#1d4ed8',
                hover_border_color: '#1d4ed8'
            },
            secondary_button: {
                background_color: "#1e3a8a",
                hover_color: '#1e40af',
                color: '#fcfcfc',
                border_color: '#1e3a8a',
                hover_border_color: '#1e3a8a'
            },
            card: {
                background_color: "#292524",
                color: '#f5f3ff',
                border_color: '#8b5cf6',
                box_shadow_color: '#a78bfa',
                show_box_shadow: true
            },
            nav: {},
            link: {},
            footer: {},
        }

    }
}